import { loginRequest } from '../../utils/AuthConfig';
import { isAPIFailed, isAPISuccess } from '../../utils/Util';
import { toast } from 'react-toastify';

export const callLogin = (e, instance) => {
  if (e) e.preventDefault();
  instance.loginRedirect(loginRequest).catch(() => {});
};

export const addListener = (instance, onSuccessfulLogin) => {
  
  instance.addEventCallback((event) => {
    if (
      event.eventType === 'msal:acquireTokenSuccess' ||
      event.eventType === 'msal:loginSuccess'
    ) {
      if (event?.payload?.account) {
        onSuccessfulLogin(event.payload);
      } else {
        callLogin(null, instance);
      }
    }
  });
};

export const getRequestData = (payload) => {
  const data = {
    employeeName: payload.account.name,
    email: payload.account.username,
    accessToken: payload.accessToken,
    accessExpiryTime: payload.expiresOn,
    resetToken: payload.idToken,
    resetExpiryTime: payload.extExpiresOn,
    mobile_device_token: null,
  };
  return data;
};

export const logoutWithTimer = (instance) => {
  setTimeout(() => {
    instance.logoutRedirect();
  }, 2000);
};

export const errorWithTimer = (message) => {
  setTimeout(() => {
    toast.error(message);
  }, 500);
};

export const validateLogin = (fulfilled, instance, dispatch) => {
 
};
